import React, { Component } from "react";
import { Table, Button } from "semantic-ui-react";
import { addReportIdToAdditionalData } from "../common/Utils";

class BusinessRecordHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      internalId: props.node.$.internalID,
      formData: props.formData,
    };
  }

  componentWillReceiveProps(nextProps) {
    const internalId = nextProps.node.$.internalID;
    this.setState({
      formData: nextProps.formData,
      internalId,
    });
  }

  onSelectReport = () => {
    const additionalData = {
      internalNameID: 1,
      bttype: this.props.userAccount.btType,
      optReportType: "corp",
    };
    addReportIdToAdditionalData(this.props, additionalData);
    this.props.showReport(
      undefined,
      "criminalReport",
      this.state.internalId,
      additionalData
    );
  };

  render() {
    return (
      <Table>
        <Table.Body>
          <Table.Row className={"result-header"}>
            <Table.Cell className={"icon-align-middle"}>
              {this.props.companyName}
            </Table.Cell>
            <Table.Cell className="float-right-nomobile">
              <Button primary onClick={() => this.onSelectReport()}>
                Report
              </Button>
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    );
  }
}

export default BusinessRecordHeader;



// WEBPACK FOOTER //
// ./src/components/searchresults/BusinessRecordHeader.js